﻿var ini = {
    tasks: [],
    debug: true
};
//
// Performs all initialisation on document ready
//

// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () { };
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

runStartupScripts = function (selecta) {
    var stuff = typeof selecta !== 'undefined' ? $(selecta) : $("*[data-mhini]");
    // loop all init functions here
    $.each(stuff, function (i, v) {
        if (ini.debug && window.console) {
            console.log("Evaluate : " + i);
            console.log("Code : " + $(v).data("mhini"));
        }
        eval($(v).data("mhini"));
    });
}
// Evaluate everything on the current page and fire it up...
$(document).ready(function () {
    // get a list of tasks...
    if (ini.debug && window.console) {
       // console.log("MH page init");
    }
    runStartupScripts();



    // rwn : spoofing no svg support
    // $('html').removeClass('svg');
    // $('html').addClass('no-svg');
});